import { render, staticRenderFns } from "./DiamondClarity.vue?vue&type=template&id=1995a464"
import script from "./DiamondClarity.vue?vue&type=script&lang=js"
export * from "./DiamondClarity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports